import React, { useEffect, useState } from 'react'
import DocumentCompare from './DocumentCompare'
import ToastManager from '../../../Components/ToastManager';
import { NetworkManager } from '../../../Components/NetworkManager';
import { CommonUtil } from '../../../utils/CommonUtil';

const InspectionDocCompare = () => {
  const saasOrgId = CommonUtil.getSaasOrgId();
  const [data, setData] = useState<any | null>(null);

  const onLoginError = (err: any) => {
    console.error("Login Error:", err);
  };
  
  useEffect(() => {
    getDocInspection();
  }, []);

  const getDocInspection = () => {
    const orgUrl = `api/dashboard/compare?orgId=${saasOrgId}&isToCompareDifferentDocs=false&docId=${CommonUtil.getInterchangeDocumentId()}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, onDocInspection, onLoginError);
  };
  
  const onDocInspection = (dataObj: any) => {
      const restData = JSON.parse(dataObj);
      if (restData && !restData.errorMessage) {
        setData(restData);
      } else {
        ToastManager.showToast(restData?.errorMessage || "Unknown error", "Error");
      }
  }

  return (
    <div>
      <DocumentCompare data={data} />
    </div>
  )
}

export default InspectionDocCompare
